/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input, message,
  Modal,
  Row,
} from 'antd';
import { getTiposDeVialidades } from 'api/catalogos/tiposVialidades';
import Table from 'components/Table';
import React, { useEffect, useState } from 'react';
import { getCodigosPostales } from '../../../api/catalogos';
import ModalSearch from '../../Direccion/ModalSearch';
import Select from '../../Select';

// eslint-disable-next-line react/prop-types
const EmpleadoDireccion = ({
  formDireccion,
  rules,
  coloniasCargadas,
  paises,
  isBlocked,
}) => {
  const [tiposDeVialidades, setTiposDeVialidades] = useState([]);
  const [visibleNoSeCodigo, setVisibleNoSeCodigo] = useState(false);
  const [colonias, setColonias] = useState([]);
  const [domicilios, setDomicilios] = useState([]);
  const [selectedDomicilio, setSelectedDomicilio] = useState(null);
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [showVigenciaModal, setShowVigenciaModal] = useState(false);
  const [vigenciaFinal, setVigenciaFinal] = useState(null);
  const [showFormModal, setShowFormModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingDireccion, setEditingDireccion] = useState(null);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [pendingDireccion, setPendingDireccion] = useState(null); // guardar temporalmente la dirección

  useEffect(() => {
    let mounted = true;

    const fetch = async () => {
      const [
        _tiposDeVialidades,
      ] = await Promise.all([
        getTiposDeVialidades(),
      ]);
      if (mounted) {
        setTiposDeVialidades(_tiposDeVialidades);
      }
    };
    fetch();
    return () => { mounted = false; };
  }, []);

  useEffect(() => {
    setColonias(coloniasCargadas);
  }, [coloniasCargadas]);

  const getFromPostalCode = (param) => {
    // setLoading(true);
    setTimeout(async () => {
      const _codigosPostales = await getCodigosPostales({ d_codigo: param });
      if (_codigosPostales.length) {
        const [firstItem] = _codigosPostales;
        const coloniasArr = _codigosPostales.map((item) => ({
          id: item.id, colonia: item.d_asenta,
        }));
        setColonias(coloniasArr);
        const estado = firstItem?.municipio?.estado?.nombre_de_AGEE || '';
        const municipio = firstItem?.municipio?.nom_mun || '';
        if (_codigosPostales.length === 1) {
          formDireccion.setFieldsValue({
            pais_codigo_postal: 'México',
            colonia: firstItem.d_asenta,
            d_codigo: firstItem.d_codigo,
            estado,
            municipio,
          });
        } else {
          formDireccion.setFieldsValue({
            pais_codigo_postal: 'México',
            d_codigo: firstItem.d_codigo,
            estado,
            municipio,
            colonia: firstItem.d_asenta,
          });
        }
      } else {
        message.info('No se encontro información relacionada al código postal brindado');
        formDireccion.setFieldsValue({
          pais_codigo_postal: 'México',
          codigo_posta: undefined,
          d_codigo: undefined,
          estado: undefined,
          municipio: undefined,
          colonia: undefined,
        });
      }
    }, 300);
    // setLoading(false);
  };

  const onFinishSearch = async (values) => {
    if (values) {
      const _codigosPostales = await getCodigosPostales({ d_codigo: values.d_codigo });
      if (_codigosPostales.length) {
        const coloniasArr = _codigosPostales.map((item) => ({
          id: item.id, colonia: item.d_asenta,
        }));
        setColonias(coloniasArr);
        formDireccion.setFieldsValue({
          pais_codigo_postal: 'México',
          codigo_postal: values.id,
          colonia: values.d_asenta,
          d_codigo: values.d_codigo,
          estado: values.nombre_de_AGEE,
          municipio: values.municipio.nom_mun,
        });
      } else {
        message.warn('Seleccione un elemento');
      }
    }
  };
  // Cambiar domicilio desde el botón
  const handleBotonCambiarDireccion = () => {
    if (selectedDomicilio === null) {
      message.warning('Selecciona un domicilio del grid para cambiar.');
      return;
    }
    const domicilio = domicilios[selectedDomicilio];
    setSelectedDomicilio(domicilio);
    setShowChangeModal(true);
  };

  // Cuando el usuario confirma en el modal de confirmación
  const handleConfirmChange = () => {
    setShowChangeModal(false);
    setShowVigenciaModal(true); // Muestra el modal de vigencia
  };

  const handleVigenciaOk = () => {
    if (pendingDireccion) {
      const nuevaDireccion = { ...pendingDireccion, estatus: 'Vigente', vigencia: vigenciaFinal?.format('YYYY-MM-DD') };
      if (isEditing && editingDireccion) {
        setDomicilios(
          domicilios.map((d) => (d === editingDireccion ? { ...editingDireccion, ...nuevaDireccion } : d)),
        );
      } else {
        setDomicilios([...domicilios, nuevaDireccion]);
      }
    }
    setShowVigenciaModal(false);
    setShowFormModal(false);
    setEditingDireccion(null);
    setPendingDireccion(null);
    setVigenciaFinal(null);
  };

  // --- Información dummy para simular domicilios registrados ---
  useEffect(() => {
    if (domicilios.length === 0) {
      setDomicilios([
        // Vigentes
        {
          id: 1,
          tipo_de_direccion: 2,
          calle_principal: 'Av. Reforma',
          colonia: 'Centro',
          municipio: 'Cuauhtémoc',
          estado: 'CDMX',
          vigencia: '2025-12-31',
          observaciones: 'Domicilio fiscal principal',
          estatus: 'Vigente',
        },
        {
          id: 2,
          tipo_de_direccion: 3,
          calle_principal: 'Insurgentes Sur',
          colonia: 'Del Valle',
          municipio: 'Benito Juárez',
          estado: 'CDMX',
          vigencia: '2024-12-31',
          observaciones: 'Domicilio personal',
          estatus: 'Vigente',
        },
        // No vigentes
        {
          id: 3,
          tipo_de_direccion: 2,
          calle_principal: 'Av. Juárez',
          colonia: 'Centro Histórico',
          municipio: 'Cuauhtémoc',
          estado: 'CDMX',
          vigencia: '2023-12-31',
          observaciones: 'Domicilio anterior',
          estatus: 'No vigente',
        },
        {
          id: 4,
          tipo_de_direccion: 3,
          calle_principal: 'Revolución',
          colonia: 'Tacuba',
          municipio: 'Miguel Hidalgo',
          estado: 'CDMX',
          vigencia: '2022-12-31',
          observaciones: 'Domicilio personal anterior',
          estatus: 'No vigente',
        },
      ]);
    }
  }, []);

  // Cuando se selecciona una fila del grid, llenar el formulario con sus datos
  useEffect(() => {
    if (selectedDomicilio !== null && domicilios[selectedDomicilio]) {
      formDireccion.setFieldsValue({ ...domicilios[selectedDomicilio] });
    }
  }, [selectedDomicilio]);

  // Filtrar direcciones vigentes y no vigentes
  const direccionesVigentes = domicilios.filter((d) => d.estatus === 'Vigente');
  const direccionesNoVigentes = domicilios.filter((d) => d.estatus !== 'Vigente');

  // Definir las funciones de control para la tabla
  const onClickAdd = () => {
    setIsEditing(false);
    setEditingDireccion(null);
    formDireccion.resetFields();
    setShowFormModal(true);
  };

  const onClickEdit = () => {
    if (selectedRowKey) {
      // Buscar la dirección seleccionada por id
      const direccion = direccionesVigentes.find((d) => d.id === selectedRowKey);
      if (direccion) {
        setIsEditing(true);
        setEditingDireccion(direccion);
        formDireccion.setFieldsValue(direccion);
        setShowFormModal(true);
      }
    }
  };

  const rowSelection = {
    selectedRowKeys: selectedRowKey ? [selectedRowKey] : [],
    type: 'radio',
    onChange: (selectedKeys) => setSelectedRowKey(selectedKeys[0]),
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKey(record.id);
  };

  const handleFormModalOk = async () => {
    try {
      const values = await formDireccion.validateFields();
      setPendingDireccion(values); // Guarda los datos temporalmente
      setShowChangeModal(true); // Muestra el modal de confirmación
    } catch (err) {
      // Los mensajes de error se mostrarán automáticamente por antd
    }
  };

  // Actualizar columnas para que incluyan todos los campos del formulario (formato correcto)
  const columnsVigentes = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      titleText: 'Tipo de Dirección',
      dataIndex: 'tipo_de_direccion',
      key: 'tipo_de_direccion',
      width: 120,
      render: (tipo) => {
        switch (tipo) {
          case 2: return 'Fiscal';
          case 3: return 'Personal';
          case 4: return 'Fiscal y Personal';
          default: return 'No aplica';
        }
      },
    },
    {
      titleText: 'País',
      dataIndex: 'pais_codigo_postal',
      key: 'pais_codigo_postal',
      width: 100,
    },
    {
      titleText: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      width: 100,
    },
    {
      titleText: 'Municipio',
      dataIndex: 'municipio',
      key: 'municipio',
      width: 100,
    },
    {
      titleText: 'Colonia',
      dataIndex: 'colonia',
      key: 'colonia',
      width: 120,
    },
    {
      titleText: 'Código Postal',
      dataIndex: 'd_codigo',
      key: 'd_codigo',
      width: 100,
    },
    {
      titleText: 'Número Exterior',
      dataIndex: 'numero_exterior',
      key: 'numero_exterior',
      width: 100,
    },
    {
      titleText: 'Número Interior',
      dataIndex: 'numero_interior',
      key: 'numero_interior',
      width: 100,
    },
    {
      titleText: 'Tipo de Vialidad',
      dataIndex: 'tipo_de_vialidad',
      key: 'tipo_de_vialidad',
      width: 120,
    },
    {
      titleText: 'Vialidad',
      dataIndex: 'calle_principal',
      key: 'calle_principal',
      width: 120,
    },
    {
      titleText: 'Tipo de Vialidad Entre',
      dataIndex: 'tipo_de_vialidad_entre',
      key: 'tipo_de_vialidad_entre',
      width: 120,
    },
    {
      titleText: 'Entre Vialidad',
      dataIndex: 'entre_calle',
      key: 'entre_calle',
      width: 120,
    },
    {
      titleText: 'Tipo de Vialidad Y Calle',
      dataIndex: 'tipo_de_vialidad_y_calle',
      key: 'tipo_de_vialidad_y_calle',
      width: 120,
    },
    {
      titleText: 'Y Vialidad',
      dataIndex: 'y_calle',
      key: 'y_calle',
      width: 120,
    },
    {
      titleText: 'Descripción de la Ubicación',
      dataIndex: 'descripcion_de_la_ubicacion',
      key: 'descripcion_de_la_ubicacion',
      width: 180,
    },
    {
      titleText: 'Vigencia',
      dataIndex: 'vigencia',
      key: 'vigencia',
      width: 100,
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 160,
      render: (_, record) => {
        if (!record.calle_principal || !record.colonia) {
          return 'Falta registrar una Dirección';
        }
        return record.observaciones || '';
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estatus',
      key: 'estatus',
      width: 100,
    },
  ];

  // Definir columnas para historial si se desea diferente, o usar las mismas

  // Permisos dummy para pruebas (simula permisos otorgados)
  const direccionPermission = {
    add: true,
    change: true,
    view: true,
    delete: true,
    export: true,
    import: true,
    sync: true,
    authorize: true,
    cancel: true,
    hasAllViewPermission: true,
  };

  return (
    <>
      {/* Tabla de direcciones vigentes con selección de fila */}
      <Table
        title={() => 'Direcciones vigentes'}
        cols={columnsVigentes}
        data={direccionesVigentes}
        rowSelection={rowSelection}
        rowKey="id"
        handleOnRowClick={handleOnRowClick}
        controls={{
          onClickAdd,
          onClickEdit,
        }}
        addText="Agregar dirección"
        editText="Editar dirección"
        allowExportPDF={false}
        disableAdd={false}
        disableEdit={!selectedRowKey}
        permission={direccionPermission}
      />
      {/* Tabla de historial de direcciones no vigentes */}
      <Table
        title={() => 'Historial de direcciones no vigentes'}
        cols={columnsVigentes}
        data={direccionesNoVigentes}
        rowKey="id"
        style={{ marginTop: 24 }}
        pagination={false}
        permission={direccionPermission}
      />
      {/* Modal de confirmación para cambiar domicilio */}
      <Modal
        open={showChangeModal}
        onOk={handleConfirmChange}
        onCancel={() => setShowChangeModal(false)}
        okText="Sí"
        cancelText="No"
        title="¿Desea cambiar el domicilio seleccionado?"
      >
        <p>¿Desea cambiar el domicilio seleccionado?</p>
      </Modal>

      {/* Modal para capturar fecha de vigencia final */}
      <Modal
        open={showVigenciaModal}
        onOk={handleVigenciaOk}
        onCancel={() => setShowVigenciaModal(false)}
        okText="Guardar"
        cancelText="Cancelar"
        title="Registrar Fecha de Vigencia Final"
      >
        <DatePicker
          value={vigenciaFinal}
          onChange={setVigenciaFinal}
          format="YYYY-MM-DD"
          style={{ width: '100%' }}
        />
      </Modal>

      {/* Modal con el formulario de dirección */}
      <Modal
        open={showFormModal}
        onOk={handleFormModalOk}
        onCancel={() => setShowFormModal(false)}
        okText={isEditing ? 'Guardar cambios' : 'Agregar'}
        cancelText="Cancelar"
        title={isEditing ? 'Editar dirección' : 'Agregar dirección'}
        destroyOnClose
        width="80%"
      >
        <Form
          layout="vertical"
          form={formDireccion}
          scrollToFirstError
          name="direccionFormModal"
          initialValues={{ pais: 'México', estados_globales: 1 }}
          onValuesChange={async (changedValues) => {
            if (changedValues.d_codigo?.length === 5) {
              getFromPostalCode(changedValues.d_codigo);
            }
          }}
        >
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          <Form.Item name="codigo_postal" hidden>
            <Input />
          </Form.Item>
          <Row gutter={10}>
            <Col xs={24} sm={24} md={8}>
              <Row>
                <Form.Item
                  name="d_codigo"
                  label="Código Postal"
                  hasFeedback
                  rules={rules.required}
                  style={{ marginBottom: 0 }}
                >
                  <Input.Group compact style={{ display: 'flex', alignItems: 'center' }}>
                    <Input
                      allowClear
                      style={{ flex: 1, marginRight: 8 }}
                      maxLength={5}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value.length === 5) {
                          getFromPostalCode(value);
                        }
                      }}
                    />
                    <Button
                      type="link"
                      onClick={() => setVisibleNoSeCodigo(true)}
                      className="primary-on-hover"
                      style={{ padding: 0, minWidth: 0 }}
                    >
                      No sé mi código
                    </Button>
                  </Input.Group>
                </Form.Item>
              </Row>
            </Col>
            <Col xs={24} sm={24} md={16}>
              <Row gutter={8} align="middle" style={{ width: '100%' }}>
                <Col xs={24} sm={12} md={12} style={{ width: '50%' }}>
                  <Form.Item
                    name="tipo_de_direccion"
                    label="Tipo de Dirección"
                    hasFeedback
                    style={{ width: '100%' }}
                  >
                    <Select
                      labelProp="nombre"
                      dataSource={[
                        { id: 1, nombre: 'No aplica' },
                        { id: 2, nombre: 'Domicilio Fiscal' },
                        { id: 3, nombre: 'Domicilio Personal' },
                        { id: 4, nombre: 'Domicilio Fiscal y Personal' },
                      ]}
                      render={(item) => `${item.id} - ${item.nombre}`}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={12} style={{ width: '50%' }}>
                  {/*  */}
                </Col>
              </Row>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="pais_codigo_postal"
                label="País"
                hasFeedback
              >
                <Select
                  labelProp="nombre"
                  dataSource={paises}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="estado"
                label="Estado"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="municipio"
                label="Municipio"
                hasFeedback
              >
                <Input allowClear disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="colonia"
                label="Colonia"
                hasFeedback
              >
                <Select
                  valueProp="colonia"
                  labelProp="colonia"
                  keyProp="id"
                  dataSource={colonias}
                  onChange={(value) => {
                    if (value === undefined) {
                      formDireccion.setFieldsValue({ colonia: null });
                    }
                  }}
                  disabled={isBlocked}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="numero_exterior"
                label="Número Exterior"
                // rules={rules.required}
                hasFeedback
              >
                <Input
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Form.Item
                name="numero_interior"
                label="Número Interior"
                hasFeedback
              >
                <Input
                  allowClear
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Input.Group style={{ display: 'flex' }} className="select-input" compact>
                <Form.Item
                  style={{ width: 150 }}
                  name="tipo_de_vialidad"
                  label="Tipo"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={tiposDeVialidades}
                  />
                </Form.Item>
                <Form.Item
                  style={{ width: '100%' }}
                  name="calle_principal"
                  label="Vialidad"
                  hasFeedback
                  rules={rules.required}
                >
                  <Input
                    allowClear
                  />
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Input.Group style={{ display: 'flex' }} className="select-input" compact>
                <Form.Item
                  style={{ width: 150 }}
                  name="tipo_de_vialidad_entre"
                  label="Tipo"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={tiposDeVialidades}
                  />
                </Form.Item>
                <Form.Item
                  style={{ width: '100%' }}
                  name="entre_calle"
                  label="Entre Vialidad"
                  hasFeedback
                >
                  <Input
                    allowClear
                  />
                </Form.Item>
              </Input.Group>
            </Col>
            <Col xs={24} sm={24} md={8}>
              <Input.Group style={{ display: 'flex' }} className="select-input" compact>
                <Form.Item
                  style={{ width: 150 }}
                  name="tipo_de_vialidad_y_calle"
                  label="Tipo"
                  hasFeedback
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={tiposDeVialidades}
                  />
                </Form.Item>
                <Form.Item
                  style={{ width: '100%' }}
                  name="y_calle"
                  label="Y Vialidad"
                  hasFeedback
                >
                  <Input
                    allowClear
                  />
                </Form.Item>
              </Input.Group>
            </Col>
            <Col span={24}>
              <Form.Item
                name="descripcion_de_la_ubicacion"
                label="Descripción de la Ubicación"
                hasFeedback
              >
                <Input.TextArea
                  autoSize={{ minRows: 2, maxRows: 3 }}
                  maxLength={250}
                  allowClear
                />
              </Form.Item>
            </Col>
            <ModalSearch
              callback={onFinishSearch}
              setVisible={setVisibleNoSeCodigo}
              open={visibleNoSeCodigo}
            />
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default EmpleadoDireccion;
